let table_BillItemEdit = require("../../templates/table/BillItemEdit.handlebars");
let table_BillItemStatus = require("../../templates/table/BillItemStatus.handlebars");
let table_BillItemCancel = require("../../templates/table/BillItemCancel.handlebars");
let PasswordEntry = require("../../templates/pos/comp/PasswordEntry.handlebars");
let PasswordEntryView = require("../comp/PasswordEntryView.js");
let Backbone = require("backbone");
import ModalView from "../comp/ModalView.js";
let _ = require("underscore");
import POS from "../../POS.js";

let DbRecorder = require("../../recorder/DbRecorder.js");

let PrinterUtil = require("../../utils/PrinterUtil.js");
import i18n from "../../utils/i18n";
import PrintService from "../../service/PrintService";

let main = function () {
    return Backbone.View.extend({
        table: null,
        bill: null,
        refundModel: null,
        events: {
            "click #billitem-edit ul.item-status li": "_itemStatusChange",
            "click #billitem-cancel ul.reasons li": "_reasonChange",
            "click button.btn-primary": "_save",
            "click button.refund": "_refundConfirm",
            "click #billitem-edit .urge": "_urgeItem",
            "click #billitem-edit .info .minus-btn": "minusNum",
            "click #billitem-edit .info .plus-btn": "plusNum",
        },

        initialize: function (options) {
            this.table = options.table;
            this.bill = options.bill;
            return this;
        },

        //增加退品数量
        plusNum: function () {
            var self = this, quantityInput = $(".info .order-quantity");
            var refundQuantity = this.refundModel.get("refundQuantity");
            console.log("plusNum", refundQuantity);
            if (refundQuantity >= this.model.get("orderedQuantity")) {
                return;
            }
            quantityInput.text(refundQuantity + 1);
            this.refundModel.set({refundQuantity: refundQuantity + 1}, {silent: true});
        },
        //减少退品
        minusNum: function () {
            var self = this, quantityInput = $(".info .order-quantity");
            var refundQuantity = this.refundModel.get("refundQuantity");
            console.log("minusNum", refundQuantity);
            if (refundQuantity <= 1) {
                return;
            }
            quantityInput.text(refundQuantity - 1);
            this.refundModel.set({refundQuantity: refundQuantity - 1}, {silent: true});
        },
        switchItem: function (evt) {
            var self = this;
            if (!this.switchItemModalView) {
                this.switchItemModalView = new SwitchItemModalView();
            }
            this.switchItemModalView.model = new Backbone.Collection(this.model);
            this.switchItemModalView.table = this.table;
            this.switchItemModalView.bill = this.bill;
            this.switchItemModalView.render();
            this.listenToOnce(this.switchItemModalView, "closed", function () {
                self.$el.modal('hide');
            });
        },
        render: function () {
            var json = this.model.toJSON(), self = this;
            console.log(json);
            this.refundModel = new Backbone.Model({refundQuantity: this.model.get("orderedQuantity")});
            var returnSlip = POS.get("printSettingModel").get("returnSlip") == false;
            if (returnSlip) {
                json.disabledRefundBtn = "refundBtnVisible";
            } else {
                json.disabledRefundBtn = "";
            }
            json.price = POS.get("restaurantModel").get("currencySymbol") + json.price;
            json.urge = json.status == "Completed";
            json.tags = json.tags ? json.tags.toJSON() : null;
            json.discount = json.discount ? json.discount : null;
            json.discountName = json.discount ? (json.discount.name ? json.discount.name : json.discount.toJSON().name) : null;
            json.menuItemName = json.menuItem.status == 'Unavailable' ? json.menuItem.name.split('-')[1] + i18n.msg('pos.menu.item.delete') : json.menuItem.name;
            this.$(".menuitem-info").empty().append(table_BillItemEdit(json));
            if (self.bill.get("pingId") || self.bill.get("hasComment") || self.bill.get("status") == "Paid") {
                this.$(".menuitem-status").find("a[href='#menuitem-modal-cancel']").hide();
            } else {
                this.$(".menuitem-status").find("a[href='#menuitem-modal-cancel']").show();
            }
            this.$("#menuitem-modal-status").empty().append(table_BillItemStatus(json));
            this.$("#menuitem-modal-cancel").empty().append(table_BillItemCancel(json));
            returnSlip ? self.$("#refundItem").prop("checked", false) : self.$("#refundItem").prop("checked", true);
            this.$el.modal('show');
        },

        _itemStatusChange: function (evt) {
            var target = $(evt.currentTarget);
            target.closest("ul").attr("status", target.data("value"));
            $(evt.currentTarget).attr("disable", "disabled");
            this.model.set("status", this.$(".item-status").attr("status"));
            this._postStatusChange();
            $(evt.currentTarget).removeAttr("disable");
            this.$el.modal('hide');
        },

        _postStatusChange: function () {
            var self = this, jxhr, status = self.model.get("status"), data;
            if (!self.model.id) {
                return;
            }
            data = {restaurantId: POS.getRestaurant().id, id: self.model.id, status: status};
            jxhr = $.post("/bill/updateBillItemStatus", data);
            jxhr.fail(function (resopnse) {
                console.log("Failed to update bill item status " + self.model.id);
            });
        },

        _reasonChange: function (evt) {
            var target = $(evt.currentTarget);
            target.addClass("active");
            target.siblings("li.active").removeClass("active");
            if (target.hasClass("others")) {
                this.$(".reason-input").show();
            } else {
                this.$(".reason-input").hide();
            }
        },

        _urgeItem: function (evt) {
            var self = this, billDetail, editorExtensionId = DbRecorder.read("chromeAppId"),
                id = $(evt.currentTarget).closest("#billitem-edit").data("id"), data, restaurant = POS.getRestaurant();
            var billitem = self.model;
            if (billitem) {
                billitem = billitem.toJSON();
                billDetail = DbRecorder.convert2JSON(self.bill);
                if (restaurant.get('fastFood')) {
                    billDetail.fastfood = true;
                }
                billDetail.table = self.table.toJSON();
            }

            PrintService.printItemReceipts(billDetail, billitem, "ReEachItem");
            alert(i18n.msg('pos.table.item.urge.success'));
            self.$el.modal('hide');
        },

        // 退菜按钮事件
        _refundConfirm: function () {
            // console.log("退菜");
            var self = this;
            // 获取订单的状态
            var billStatus = self.bill.get("status");
            // if (!POS.getUser().isAdmin && POS.getRestaurant().get('staffCashier') && (billStatus == "Paid" || billStatus == "Completed")) {
            if (!POS.getUser().isAdmin &&  POS.getRestaurant().get('staffCashier')) {
                var admins = POS.getRestaurantAdmins();
                var passwordEntryEl = $(PasswordEntry({admins: admins}));
                var model = new Backbone.Model();
                var passwordEntry = new PasswordEntryView({el: passwordEntryEl, model: model});
                var passwordModalView = new ModalView({
                    body: passwordEntryEl,
                    hideFooter: true
                }).render();
                passwordModalView.$el.find('.modal-content').addClass('passwordModal');
                passwordModalView.listenToOnce(model, "confirm", function () {
                    self._refund();
                    passwordModalView.close();
                });
                passwordModalView.listenToOnce(model, "cancel", passwordModalView.close, passwordModalView);
            } else {
                // console.log("开始退菜1");
                // 调用退菜的方法
                this._refund();
            }
        },
        _refund: function () {
            // 132
            var self = this;
            var li = self.$("ul.reasons li.active");
            // 原因
            var reason = "";
            var refundQuantity = self.refundModel.get("refundQuantity");
            var restaurant = POS.getRestaurant();
            var printSetting = POS.getPrinterSetting();
            if (li.hasClass("others")) {
                reason = this.$("textarea.reason-other").val();
            } else {
                reason = li.text();
            }
            reason = $.trim(reason);
            if (reason.length <= 0) {
                alert(i18n.msg("pos.table.item.refund.warning"));
                return false;
            }
            POS.showLoading(true);
            if (self.model.get("packageId")) {
                self.bill.getPackItemsFromPackId(self.model.get("packageId")).each(function (pack) {
                    pack.refund(reason, refundQuantity);
                    var billDetail;
                    billDetail = DbRecorder.convert2JSON(self.bill);
                    if (restaurant.get('fastFood')) {
                        billDetail.fastfood = true;
                    }
                    if (printSetting.get("returnSlip")) {
                        billDetail.table = self.table.toJSON();
                        PrintService.printItemReceipts(billDetail, DbRecorder.convert2JSON(pack), "Refund", refundQuantity);
                    }
                    self.$el.modal("hide");
                });
            } else {
                self.model.refund(reason, refundQuantity);
                var billDetail;
                billDetail = DbRecorder.convert2JSON(self.bill);
                if (restaurant.get('fastFood')) {
                    billDetail.fastfood = true;
                }
                if (printSetting.get("returnSlip")) {
                    billDetail.table = self.table.toJSON();
                    PrintService.printItemReceipts(billDetail, DbRecorder.convert2JSON(self.model), "Refund", refundQuantity);
                }
                self.$el.modal("hide");
            }
            setTimeout(() => {
                POS.showLoading(false);
            }, 1500);
        }
    });
};

let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/table/BillItemModalView.js